import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReplacementSTFormFG from "./ReplacementSTFormFG";
import ReplacementSTFormRawMaterial from "./ReplacementSTFormRawMaterial";

export default function ReplacementSTForm(): JSX.Element {
  const history = useHistory();
  const location = useLocation();

  // Persist the replacement subtype in the URL so a refresh restores the tab.
  const urlSubtype = new URLSearchParams(location.search).get("subtype");
  const [activeTab, setActiveTab] = useState<"fg" | "raw_materials">(
    urlSubtype === "raw_materials" ? "raw_materials" : "fg",
  );

  const changeTab = (tab: "fg" | "raw_materials") => {
    setActiveTab(tab);
    const params = new URLSearchParams(location.search);
    params.set("subtype", tab);
    history.replace({ search: params.toString() });
  };

  return (
    <div id="warehouse-stock-transfer-replacement-form-type-select">
      <div className="px-6 pt-6">
        {/* Section Heading */}
        <div className="mb-4">
          <h2 className="text-base font-semibold text-gray-800">
            Select Replacement Type
          </h2>
          <p className="text-sm text-gray-500">
            Choose what kind of item you want to replace
          </p>
        </div>

        {/* Tabs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {/* Finished Goods */}
          <button
            id="warehouse-stock-transfer-replacement-form-type-fg-btn"
            type="button"
            onClick={() => changeTab("fg")}
            className={`text-left rounded-xl border p-4 transition-all ${
              activeTab === "fg"
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-gray-200 hover:border-gray-300"
            }`}
          >
            <div className="flex items-start gap-2">
              <span className="text-lg">📦</span>
              <div>
                <p className="text-sm font-semibold text-gray-800">
                  Finished Goods
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Use when replacing complete devices/products
                </p>
              </div>
            </div>
          </button>

          {/* Raw Materials */}
          <button
            id="warehouse-stock-transfer-replacement-form-type-raw-materials-btn"
            type="button"
            onClick={() => changeTab("raw_materials")}
            className={`text-left rounded-xl border p-4 transition-all ${
              activeTab === "raw_materials"
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-gray-200 hover:border-gray-300"
            }`}
          >
            <div className="flex items-start gap-2">
              <span className="text-lg">⚙️</span>
              <div>
                <p className="text-sm font-semibold text-gray-800">
                  Raw Materials
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Use when replacing parts or components
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>

      {activeTab === "fg" ? (
        <ReplacementSTFormFG />
      ) : (
        <ReplacementSTFormRawMaterial />
      )}
    </div>
  );
}
